// extracted by mini-css-extract-plugin
export var alt = "CartAd-module--alt--238d8";
export var container = "CartAd-module--container--a716a";
export var desktopOnly = "CartAd-module--desktopOnly--ebdcd";
export var main = "CartAd-module--main--97798";
export var mobileOnly = "CartAd-module--mobileOnly--c3eff";
export var textLeft = "CartAd-module--textLeft--55746";
export var visuallyHidden = "CartAd-module--visuallyHidden--b7047";